import { useEffect, useState } from "react";

import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

import { usePersistentTableFilterValue } from "@covertree/hooks";
import type { OptionType } from "@covertree/types";

import { Tabs } from "../Tabs";

interface TableBoxProps {
  children: React.ReactNode;
}

export interface TableFiltersProps {
  tabs: Omit<OptionType, "icon">[];
  loading?: boolean;
  onChange: (value: string) => void;
}

const TableBox = ({ children }: TableBoxProps) => (
  <Box flexGrow={1} sx={{ backgroundColor: "background.paper" }}>
    {children}
  </Box>
);

export const TableFilters = ({
  tabs,
  loading,
  onChange,
}: TableFiltersProps) => {
  const [value, setValue] = useState<number>(0);
  const { filterValue } = usePersistentTableFilterValue(tabs);

  useEffect(() => {
    setValue(filterValue);
  }, [filterValue]);

  const handleChange = (newValue: number) => {
    setValue(newValue);
    onChange(tabs[newValue].value);
  };

  return (
    <TableBox>
      <Paper elevation={0}>
        <Tabs
          tabs={tabs}
          value={value}
          onChange={handleChange}
          disabled={loading}
          variant="scrollable"
          scrollButtons="auto"
        />
      </Paper>
    </TableBox>
  );
};
